import React, { useState, useEffect } from "react";
import {
  Avatar,
  Space,
  Tooltip,
  Modal,
  Tag,
  Dropdown,
  Checkbox,
  Divider,
  Button,
  theme,
  Select,
  Input,
  Spin,
  DatePicker,
  Table,
  message,
} from "antd";
import {
  CalendarOutlined,
  CloseCircleOutlined,
  EditOutlined,
  EyeOutlined,
  LoadingOutlined,
  UserAddOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { GlobalContextType } from "../../../@types/global";
import { GlobalContext } from "../../../context/globalContext";
import "./styles.css";
import Comments from "../../Comments/Comments";
import { ModalVerTarefaTypes } from "../../../@types/modalVerTarefa";
import NewUser from "../../NewUser/NewUser";
import { useParams } from "react-router-dom";
import { TaskType } from "../../../context/taskContext";
import moment from "moment";
import ReactQuill from "react-quill";
import dayjs from "dayjs";

const { useToken } = theme;
const { Search } = Input;

const Task: React.FC<ModalVerTarefaTypes> = ({ showModal, setShowModal }) => {
  const { userInfo, usuarios, moduloTask, currentCliente, clientes } =
    React.useContext(GlobalContext) as GlobalContextType;

  const [searchValue, setSearchValue] = useState("");
  const [filteredUsuarios, setFilteredUsuarios] = useState([]);
  const [showModalNewUser, setShowModalNewUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newDate, setNewDate] = useState<any>(null); // Estado para a nova data
  const [isEditing, setIsEditing] = useState(false); // Estado para controlar o modo de edição
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editedDescription, setEditedDescription] = useState("");
  const [isEditingDescription2, setIsEditingDescription2] = useState(false);
  const [editedDescription2, setEditedDescription2] = useState("");
  const [isEditingDescription1, setIsEditingDescription1] = useState(false);
  const [editedDescription1, setEditedDescription1] = useState("");
  const [isEditingDescription3, setIsEditingDescription3] = useState(false);
  const [editedDescription3, setEditedDescription3] = useState("");
  const [editingDeadlineTaskId, setEditingDeadlineTaskId] = useState<string | null>(null);

  const handleDateChange = (date: any) => {
    setNewDate(date); // Atualiza o estado com a data selecionada
  };

  const updateDeadline = () => {
    if (newDate) {
      const cliente_id =
        moduloTask.selectedTask?.cliente_id ||
        currentCliente?._id ||
        usuarios?.find(
          (u: any) => u._id === moduloTask.selectedTask?.assignment_id
        )?.cliente_id ||
        usuarios?.find((u: any) => u._id === moduloTask.selectedTask?.owner_id)
          ?.cliente_id;

      moduloTask.selectedTask &&
        moduloTask.updateTask({
          ...moduloTask.selectedTask,
          prazo_conclusao: newDate,
          cliente_id: cliente_id,
        });
      setNewDate(null); // Limpa a seleção de data após a atualização
      setIsEditing(false); // Sai do modo de edição
    }
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const params = useParams();

  const handleSearch = (value: any) => {
    setSearchValue(value);
  };

  useEffect(() => {
    if (usuarios) {
      setFilteredUsuarios(
        usuarios.filter((usr: any) =>
          usr.name?.toLowerCase()?.includes(searchValue.toLowerCase())
        )
      );
    }
  }, [searchValue, usuarios]);

  useEffect(() => {
    if (moduloTask.selectedTask?.description) {
      setEditedDescription(moduloTask.selectedTask.description);
    }
    if (moduloTask.selectedTask?.description_1) {
      setEditedDescription1(moduloTask.selectedTask.description_1);
    }
    if (moduloTask.selectedTask?.description_2) {
      setEditedDescription2(moduloTask.selectedTask.description_2);
    }
    if (moduloTask.selectedTask?.description_3) {
      setEditedDescription3(moduloTask.selectedTask.description_3);
    }
  }, [moduloTask.selectedTask?.description, moduloTask.selectedTask?.description_1, moduloTask.selectedTask?.description_2, moduloTask.selectedTask?.description_3]);

  const { token } = useToken();

  const contentStyle: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
    width: "300px",
    maxHeight: "800px",
    overflowY: "auto",
    overflowX: "hidden",
  };

  const menuStyle: React.CSSProperties = {
    boxShadow: "none",
  };

  const handleShowModal = () => {
    showModal ? setShowModal(false) : setShowModal(true);
  };

  const taskCorretas = (taskCli: TaskType[], other: TaskType[]) => {
    const tasksCliente = taskCli?.filter(
      (task: any) =>
        task.tipo_dependencia === "checklist" &&
        task.dependencia === moduloTask.selectedTask?._id
    );

    const otherTasks = other?.filter(
      (task: any) =>
        task.tipo_dependencia === "checklist" &&
        task.dependencia === moduloTask.selectedTask?._id
    );

    if (tasksCliente?.[0]) {
      return tasksCliente;
    } else {
      return otherTasks;
    }
  };

  const handleMenuClick = (e: any) => {
    moduloTask.selectedTask &&
      moduloTask.updateTask({
        ...moduloTask.selectedTask,
        status: e.key,
        cliente_id:
          moduloTask.selectedTask?.cliente_id ||
          currentCliente?._id ||
          usuarios?.find(
            (u: any) => u._id === moduloTask.selectedTask?.assignment_id
          )?.cliente_id ||
          usuarios?.find(
            (u: any) => u._id === moduloTask.selectedTask?.owner_id
          )?.cliente_id,
      });
  };

  const items: any = [
    {
      key: "Pendente",
      label: "Pendente",
      onClick: handleMenuClick,
    },
    {
      key: "Em andamento",
      label: "Em andamento",
      onClick: handleMenuClick,
    },
    {
      key: "Concluída",
      label: "Concluída",
      onClick: handleMenuClick,
    },
  ];

  const disabledDate = (current: any) => {
    return current && current < moment().startOf("day");
  };

  const columns = [
    {
      title: "Cliente",
      key: "cliente",
      render: () =>
        clientes?.find(
          (c: any) =>
            c._id ===
            (moduloTask.selectedTask?.cliente_id ||
              currentCliente?._id ||
              usuarios?.find(
                (u: any) => u._id === moduloTask.selectedTask?.assignment_id
              )?.cliente_id ||
              usuarios?.find(
                (u: any) => u._id === moduloTask.selectedTask?.owner_id
              )?.cliente_id)
        )?.razao_social || "-",
    },
    {
      title: "Atribuído",
      key: "atribuido",
      render: () => (
        <div
          className="microtask_user"
          style={{
            width: "fit-content",
          }}
        >
          <Avatar
            className="avatar-task"
            src={`https://ui-avatars.com/api/?name=${moduloTask.selectedTask?.assignment_name?.replaceAll(
              " ",
              "+"
            )}?size=128?background=ebebeb`}
          />
          <p>
            {moduloTask.selectedTask?.assignment_name ||
              usuarios?.find(
                (u: any) => u._id === moduloTask.selectedTask?.assignment_id
              )?.name ||
              ""}
          </p>

          <Tooltip title="Alterar atribuíção">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "auto",
              }}
            >
              {loading && (
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />}
                />
              )}
              <Dropdown
                placement="bottom"
                disabled={loading}
                trigger={["click"]}
                menu={{
                  items: [
                    {
                      key: "1",
                      type: "group",
                      label: "Consultores",
                      children: usuarios
                        ?.filter(
                          (usr: any) =>
                            usr.grupos.find(
                              (g: any) =>
                                g.name === "seusdados" || g.name === "assinante"
                            ) && usr.cliente_id === "64e648ff902fd5e820397ebb" // Seusdados
                        )
                        ?.map((usr: any) => {
                          return {
                            key: usr._id,
                            label: usr.name,
                            onClick: (v: any) => {
                              if (moduloTask?.selectedTask?._id) {
                                setLoading(true);
                                moduloTask
                                  .updateTaskAssignment(
                                    moduloTask?.selectedTask?._id,
                                    usr._id
                                  )
                                  .then((data) =>
                                    moduloTask.setSelectedTask(data)
                                  )
                                  .finally(() => setLoading(false));
                              }
                            },
                          };
                        }),
                    },
                  ],
                }}
                dropdownRender={(menu) => (
                  <div style={contentStyle}>
                    <Search
                      style={{
                        margin: "10px 18px",
                        width: "264px",
                      }}
                      placeholder="Buscar"
                      onSearch={handleSearch}
                      enterButton
                    />
                    <Divider style={{ margin: 0 }} />
                    {React.cloneElement(menu as React.ReactElement, {
                      style: menuStyle,
                    })}
                    <Divider style={{ margin: 0 }} />
                    <Space
                      style={{
                        padding: 8,
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      <Button
                        type="primary"
                        icon={<UserAddOutlined />}
                        onClick={() => setShowModalNewUser(true)}
                      >
                        Novo usuário
                      </Button>
                    </Space>
                  </div>
                )}
              >
                <EditOutlined style={{ marginLeft: "0.5rem", color: "#000" }} />
              </Dropdown>
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Criado por",
      key: "criadopor",
      render: () => (
        <div className="microtask_user">
          <Avatar
            className="avatar-task"
            src={`https://ui-avatars.com/api/?name=${moduloTask.selectedTask?.owner_name?.replaceAll(
              " ",
              "+"
            )}?background=ebebeb`}
          />
          <p>
            {moduloTask.selectedTask?.owner_name ||
              usuarios?.find(
                (u: any) => u._id === moduloTask.selectedTask?.owner_id
              )?.name ||
              ""}
          </p>
        </div>
      ),
    },
    {
      title: "Prazo",
      key: "prazo",
      render: () => (
        <div>
          <Tooltip title={isEditing ? "Cancelar edição" : "Editar prazo"}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#5f29cc",
              }}
              onClick={handleEditClick}
            >
              <CalendarOutlined style={{ fontSize: "1.2rem" }} />
              {moduloTask.selectedTask?.prazo_conclusao ? (
                <span style={{ marginLeft: "0.5rem" }}>
                  {moment(moduloTask.selectedTask.prazo_conclusao).format("DD/MM/YYYY")}
                </span>
              ) : (
                <span style={{ marginLeft: "0.5rem", color: "#999" }}>
                  {isEditing ? "Cancelar edição" : "Definir prazo"}
                </span>
              )}
            </div>
          </Tooltip>
          {isEditing && (
            <div style={{ display: "flex", alignItems: "center",marginTop: "0.5rem"}}>
              <DatePicker
                onChange={handleDateChange}
                format="DD/MM/YYYY"
                value={newDate}
                size="small"
                disabledDate={disabledDate}
                placeholder="Selecione uma data"
                style={{width: "180px", marginRight: "0.25rem"}}
              />
              <Button
                type="primary"
                size="small"
                onClick={updateDeadline}
                disabled={!newDate}
              >
                Salvar
              </Button>
            </div>
          )}
        </div>
      ),
    },
  ];

  const handleUpdateDescription = () => {
    if (editedDescription && moduloTask.selectedTask) {
      const cliente_id =
        moduloTask.selectedTask?.cliente_id ||
        currentCliente?._id ||
        usuarios?.find(
          (u: any) => u._id === moduloTask.selectedTask?.assignment_id
        )?.cliente_id ||
        usuarios?.find((u: any) => u._id === moduloTask.selectedTask?.owner_id)
          ?.cliente_id;

      moduloTask.updateTask({
        ...moduloTask.selectedTask,
        description: editedDescription,
        cliente_id: cliente_id,
      });
      setIsEditingDescription(false);
    }
  };

  const handleUpdateDescription1 = () => {
    if (editedDescription1 && moduloTask.selectedTask) {
      const cliente_id =
        moduloTask.selectedTask?.cliente_id ||
        currentCliente?._id ||
        usuarios?.find(
          (u: any) => u._id === moduloTask.selectedTask?.assignment_id
        )?.cliente_id ||
        usuarios?.find((u: any) => u._id === moduloTask.selectedTask?.owner_id)
          ?.cliente_id;

      moduloTask.updateTask({
        ...moduloTask.selectedTask,
        description_1: editedDescription1,
        cliente_id: cliente_id,
      });
      setIsEditingDescription1(false);
    }
  };

  const handleUpdateDescription2 = () => {
    if (editedDescription2 && moduloTask.selectedTask) {
      const cliente_id =
        moduloTask.selectedTask?.cliente_id ||
        currentCliente?._id ||
        usuarios?.find(
          (u: any) => u._id === moduloTask.selectedTask?.assignment_id
        )?.cliente_id ||
        usuarios?.find((u: any) => u._id === moduloTask.selectedTask?.owner_id)
          ?.cliente_id;

      moduloTask.updateTask({
        ...moduloTask.selectedTask,
        description_2: editedDescription2,
        cliente_id: cliente_id,
      });
      setIsEditingDescription2(false);
    }
  };

  const handleUpdateDescription3 = () => {
    if (editedDescription3 && moduloTask.selectedTask) {
      const cliente_id =
        moduloTask.selectedTask?.cliente_id ||
        currentCliente?._id ||
        usuarios?.find(
          (u: any) => u._id === moduloTask.selectedTask?.assignment_id
        )?.cliente_id ||
        usuarios?.find((u: any) => u._id === moduloTask.selectedTask?.owner_id)
          ?.cliente_id;

      moduloTask.updateTask({
        ...moduloTask.selectedTask,
        description_3: editedDescription3,
        cliente_id: cliente_id,
      });
      setIsEditingDescription3(false);
    }
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'color': [] }, { 'background': [] }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'color', 'background',
    'link'
  ];

  return (
    <>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            {moduloTask.selectedTask?.tipo_dependencia === "checklist" && (
              <Tooltip title="Voltar para tarefa principal">
                <ArrowLeftOutlined
                  style={{
                    color: "#1677ff",
                    fontSize: "1.2rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const parentTask = [...(moduloTask.tasksCliente || []), ...(moduloTask.tasks || [])].find(
                      (t: any) => t._id === moduloTask.selectedTask?.dependencia
                    );
                    if (parentTask) {
                      moduloTask.setSelectedTask(parentTask);
                    }
                  }}
                />
              </Tooltip>
            )}
            {moduloTask.selectedTask
              ? moduloTask.selectedTask.tipo === "pauta"
                ? moduloTask.selectedTask.title
                : "Tarefa: " + moduloTask.selectedTask.title
              : ""}
          </div>
        }
        open={showModal}
        style={{ maxWidth: 1000, top: 20 }}
        footer={[]}
        width={"90%"}
        onCancel={handleShowModal}
      >
        {userInfo?.grupos?.find(
          (gp: any) => gp.name === "assinante" || gp.name === "seusdados"
        ) ? (
          <Dropdown
            menu={{
              items,
            }}
          >
            <Space style={{ cursor: "pointer" }}>
              <Tag
                style={{
                  marginTop: "0.5rem",
                  marginBottom: "0.5rem",
                }}
                color={
                  moduloTask.selectedTask?.status === "Em andamento"
                    ? "blue"
                    : moduloTask.selectedTask?.status === "Concluída"
                    ? "green"
                    : "grey"
                }
              >
                {moduloTask.selectedTask?.status}
              </Tag>
              <EditOutlined />
            </Space>
          </Dropdown>
        ) : (
          <Tag
            style={{
              marginTop: "0.5rem",
              marginBottom: "0.5rem",
            }}
            color={
              moduloTask.selectedTask?.status === "Em andamento"
                ? "blue"
                : moduloTask.selectedTask?.status === "Concluída"
                ? "green"
                : "grey"
            }
          >
            {moduloTask.selectedTask?.status}
          </Tag>
        )}
        {moduloTask?.selectedTask?.tipo !== "pauta" && (
          <Table
            style={{ marginTop: "1rem" }}
            size="small"
            dataSource={[{}]}
            columns={columns}
            pagination={false}
            bordered
          />
        )}
        <p
          style={{
            marginTop: "1rem",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          {moduloTask?.selectedTask?.description_2 ? "" : "Descrição"}
          {userInfo?.grupos?.find(
            (gp: any) => gp.name === "assinante" || gp.name === "seusdados"
          ) && (
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => setIsEditingDescription(!isEditingDescription)}
            >
              {isEditingDescription ? "Cancelar" : "Editar"}
            </Button>
          )}
        </p>
        {isEditingDescription ? (
          <div style={{ marginTop: "0.5rem" }}>
            <ReactQuill
              value={editedDescription}
              onChange={setEditedDescription}
              modules={modules}
              formats={formats}
              style={{
                background: "white",
                borderRadius: "10px",
                minHeight: "100px"
              }}
            />
            <div style={{ marginTop: "0.5rem", display: "flex", gap: "0.5rem" }}>
              <Button
                type="primary"
                size="small"
                onClick={handleUpdateDescription}
              >
                Salvar
              </Button>
              <Button
                size="small"
                onClick={() => {
                  setIsEditingDescription(false);
                  setEditedDescription(moduloTask?.selectedTask?.description || "");
                }}
              >
                Cancelar
              </Button>
            </div>
          </div>
        ) : (
          <p
            style={{
              maxHeight: moduloTask?.selectedTask?.tipo === "titular" ? "none" : "20rem",
              minHeight: "5rem",
              marginTop: "0.5rem",
              overflowY: moduloTask?.selectedTask?.tipo === "titular" ? "visible" : "auto",
              background: moduloTask?.selectedTask?.tipo === "titular" ? "#E6F3FF" : "#F3F2F1",
              borderRadius: moduloTask?.selectedTask?.tipo === "titular" ? "0" : "10px",
              borderLeft: moduloTask?.selectedTask?.tipo === "titular" ? "4px solid #1677ff" : "none",
              padding: "1rem",
            }}
            dangerouslySetInnerHTML={{
              __html:
                moduloTask?.selectedTask?.description?.replaceAll(
                  "\n",
                  "<br />"
                ) || "",
            }}
          ></p>
        )}

        {/* Campos adicionais para tipo titular */}
        {moduloTask?.selectedTask?.tipo === "titular" && (
          <>
            {/* Descrição 1 */}
            {/* {moduloTask?.selectedTask?.description_1 && (
              <>
                <p
                  style={{
                    marginTop: "1rem",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  Descrição 1
                  {userInfo?.grupos?.find(
                    (gp: any) => gp.name === "assinante" || gp.name === "seusdados"
                  ) && (
                    <Button
                      type="text"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => setIsEditingDescription1(!isEditingDescription1)}
                    >
                      {isEditingDescription1 ? "Cancelar" : "Editar"}
                    </Button>
                  )}
                </p>
                {isEditingDescription1 ? (
                  <div style={{ marginTop: "0.5rem" }}>
                    <ReactQuill
                      value={editedDescription1}
                      onChange={setEditedDescription1}
                      modules={modules}
                      formats={formats}
                      style={{
                        background: "white",
                        borderRadius: "10px",
                        minHeight: "100px"
                      }}
                    />
                    <div style={{ marginTop: "0.5rem", display: "flex", gap: "0.5rem" }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={handleUpdateDescription1}
                      >
                        Salvar
                      </Button>
                      <Button
                        size="small"
                        onClick={() => {
                          setIsEditingDescription1(false);
                          setEditedDescription1(moduloTask?.selectedTask?.description_1 || "");
                        }}
                      >
                        Cancelar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <p
                    style={{
                      maxHeight: "20rem",
                      minHeight: "5rem",
                      marginTop: "0.5rem",
                      overflowY: "auto",
                      background: "#F3F2F1",
                      borderRadius: "10px",
                      padding: "1rem",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        moduloTask?.selectedTask?.description_1?.replaceAll(
                          "\n",
                          "<br />"
                        ) || "",
                    }}
                  ></p>
                )}
              </>
            )} */}

            {/* Descrição 2 */}
            {moduloTask?.selectedTask?.description_2 && (
              <>
                <p
                  style={{
                    marginTop: "1rem",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  {/* Descrição 2 */}
                  {userInfo?.grupos?.find(
                    (gp: any) => gp.name === "assinante" || gp.name === "seusdados"
                  ) && (
                    <Button
                      type="text"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => setIsEditingDescription2(!isEditingDescription2)}
                    >
                      {isEditingDescription2 ? "Cancelar" : "Editar"}
                    </Button>
                  )}
                </p>
                {isEditingDescription2 ? (
                  <div style={{ marginTop: "0.5rem" }}>
                    <ReactQuill
                      value={editedDescription2}
                      onChange={setEditedDescription2}
                      modules={modules}
                      formats={formats}
                      style={{
                        background: "white",
                        borderRadius: "10px",
                        minHeight: "100px"
                      }}
                    />
                    <div style={{ marginTop: "0.5rem", display: "flex", gap: "0.5rem" }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={handleUpdateDescription2}
                      >
                        Salvar
                      </Button>
                      <Button
                        size="small"
                        onClick={() => {
                          setIsEditingDescription2(false);
                          setEditedDescription2(moduloTask?.selectedTask?.description_2 || "");
                        }}
                      >
                        Cancelar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <p
                    style={{
                      maxHeight: "none",
                      minHeight: "5rem",
                      marginTop: "0.5rem",
                      overflowY: "visible",
                      background: "transparent",
                      borderRadius: "10px",
                      padding: "1rem",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        moduloTask?.selectedTask?.description_2?.replaceAll(
                          "\n",
                          "<br />"
                        ) || "",
                    }}
                  ></p>
                )}
              </>
            )}

            {/* Descrição 3 */}
            {moduloTask?.selectedTask?.description_3 && (
              <>
                <p
                  style={{
                    marginTop: "1rem",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  {/* Descrição 3 */}
                  {userInfo?.grupos?.find(
                    (gp: any) => gp.name === "assinante" || gp.name === "seusdados"
                  ) && (
                    <Button
                      type="text"
                      size="small"
                      icon={<EditOutlined />}
                      onClick={() => setIsEditingDescription3(!isEditingDescription3)}
                    >
                      {isEditingDescription3 ? "Cancelar" : "Editar"}
                    </Button>
                  )}
                </p>
                {isEditingDescription3 ? (
                  <div style={{ marginTop: "0.5rem" }}>
                    <ReactQuill
                      value={editedDescription3}
                      onChange={setEditedDescription3}
                      modules={modules}
                      formats={formats}
                      style={{
                        background: "white",
                        borderRadius: "10px",
                        minHeight: "100px"
                      }}
                    />
                    <div style={{ marginTop: "0.5rem", display: "flex", gap: "0.5rem" }}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={handleUpdateDescription3}
                      >
                        Salvar
                      </Button>
                      <Button
                        size="small"
                        onClick={() => {
                          setIsEditingDescription3(false);
                          setEditedDescription3(moduloTask?.selectedTask?.description_3 || "");
                        }}
                      >
                        Cancelar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div
                    className="description-3-container"
                    style={{
                      maxHeight: "none",
                      minHeight: "5rem",
                      marginTop: "0.5rem",
                      overflowY: "visible",
                      background: "transparent",
                      borderRadius: "10px",
                      padding: "1rem",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        moduloTask?.selectedTask?.description_3?.replaceAll(
                          "\n",
                          "<br />"
                        ) || "",
                    }}
                  ></div>
                )}
              </>
            )}
          </>
        )}
        <>
          {moduloTask?.selectedTask?.prazo_conclusao && (
            <>
              <p
                style={{
                  marginTop: "1rem",
                  fontWeight: "bold",
                }}
              >
                Prazo
              </p>

              <Tooltip title={isEditing ? "Cancelar edição" : "Editar prazo"}>
                <p
                  style={{
                    color: "#5f29cc",
                    cursor: "pointer",
                    width: "fit-content",
                  }}
                  onClick={handleEditClick}
                >
                  <b>
                    <CalendarOutlined />{" "}
                    {moment(moduloTask?.selectedTask?.prazo_conclusao).format(
                      "DD/MM/YYYY"
                    )}
                    <EditOutlined
                      style={{ marginLeft: "0.5rem", color: "#000" }}
                    />
                  </b>
                </p>
              </Tooltip>
            </>
          )}

          {isEditing && ( // Exibe o componente de edição apenas no modo de edição
            <div style={{ marginTop: "1rem" }}>
              <DatePicker
                onChange={handleDateChange}
                format="DD/MM/YYYY"
                value={newDate}
                size="small"
                disabledDate={disabledDate}
                placeholder="Selecione uma nova data"
              />
              <Button
                type="primary"
                size="small"
                onClick={updateDeadline}
                style={{ marginLeft: "1rem" }}
                disabled={!newDate}
              >
                Atualizar Prazo
              </Button>
            </div>
          )}
        </>

        {(moduloTask.tasksCliente?.filter(
          (task: any) =>
            task.tipo_dependencia === "checklist" &&
            task.dependencia === moduloTask.selectedTask?._id
        )[0] ||
          moduloTask.tasks?.filter(
            (task: any) =>
              task.tipo_dependencia === "checklist" &&
              task.dependencia === moduloTask.selectedTask?._id
          )[0]) && (
          <h3
            style={{
              marginTop: "1rem",
              marginBottom: "0.5rem",
            }}
          >
            Lista de verificação
          </h3>
        )}

        {taskCorretas(moduloTask.tasksCliente, moduloTask.tasks)
          ?.filter(
            (task: any) =>
              task.tipo_dependencia === "checklist" &&
              task.dependencia === moduloTask.selectedTask?._id
          )
          ?.map((task: any) => {
            return (
              <div className="microtask_container">
                <Checkbox
                  checked={task.status === "Concluída"}
                  onChange={(e) => {
                    const newStatus = e.target.checked ? "Concluída" : "Em andamento";
                    const cliente_id =
                      task?.cliente_id ||
                      currentCliente?._id ||
                      usuarios?.find(
                        (u: any) => u._id === task?.assignment_id
                      )?.cliente_id ||
                      usuarios?.find((u: any) => u._id === task?.owner_id)
                        ?.cliente_id;

                    moduloTask.updateTask({
                      ...task,
                      status: newStatus,
                      cliente_id: cliente_id,
                    });
                  }}
                  style={{ marginRight: "0.5rem" }}
                />

                <p 
                  style={{ 
                    maxWidth: "600px",
                    cursor: "pointer",
                    opacity: task.status === "Concluída" ? 0.6 : 1,
                    textDecoration: task.status === "Concluída" ? "line-through" : "none"
                  }}
                  onClick={() => {
                    moduloTask.setSelectedTask(task);
                  }}
                >
                  {task.title}
                </p>
                <div style={{ display: "flex", alignItems: "center", marginLeft: "auto", gap: "1rem" }}>
                  <Tooltip title={editingDeadlineTaskId === task._id ? "Cancelar edição" : "Editar prazo"}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: "#5f29cc",
                      }}
                      onClick={() => {
                        setEditingDeadlineTaskId(editingDeadlineTaskId === task._id ? null : task._id);
                      }}
                    >
                      <CalendarOutlined style={{ fontSize: "1.2rem" }} />
                      {task.prazo_conclusao ? (
                        <span style={{ marginLeft: "0.5rem" }}>
                          {moment(task.prazo_conclusao).format("DD/MM/YYYY")}
                        </span>
                      ) : (
                        <span style={{ marginLeft: "0.5rem", color: "#999" }}>
                          {editingDeadlineTaskId === task._id ? "Cancelar edição" : "Definir prazo"}
                        </span>
                      )}
                    </div>
                  </Tooltip>

                  {editingDeadlineTaskId === task._id && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <DatePicker
                        onChange={(date) => {
                          if (date) {
                            const cliente_id =
                              task?.cliente_id ||
                              currentCliente?._id ||
                              usuarios?.find(
                                (u: any) => u._id === task?.assignment_id
                              )?.cliente_id ||
                              usuarios?.find((u: any) => u._id === task?.owner_id)
                                ?.cliente_id;

                            moduloTask.updateTask({
                              ...task,
                              prazo_conclusao: date,
                              cliente_id: cliente_id,
                            });
                            setEditingDeadlineTaskId(null);
                          }
                        }}
                        format="DD/MM/YYYY"
                        value={task.prazo_conclusao ? dayjs(task.prazo_conclusao) : null}
                        size="small"
                        disabledDate={disabledDate}
                        placeholder="Selecione uma data"
                        style={{ width: "180px", marginRight: "0.25rem" }}
                      />
                    </div>
                  )}

                  <Tooltip title="Alterar atribuíção">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {loading && (
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 16 }} spin />
                          }
                        />
                      )}
                      <Dropdown
                        placement="bottom"
                        disabled={loading}
                        trigger={["click"]}
                        menu={{
                          items: [
                            {
                              key: "1",
                              type: "group",
                              label: "Sponsors",
                              children: usuarios
                                ?.filter((usr: any) =>
                                  usr.grupos.find(
                                    (g: any) => g.name === "sponsor"
                                  )
                                )
                                ?.filter((usr: any) =>
                                  params.id ? usr.cliente_id === params.id : true
                                )
                                ?.map((usr: any) => {
                                  return {
                                    key: usr._id,
                                    label: usr.name,
                                    onClick: (v: any) => {
                                      setLoading(true);
                                      moduloTask
                                        .updateTaskAssignment(task._id, usr._id)
                                        .finally(() => setLoading(false));
                                    },
                                  };
                                }),
                            },
                            {
                              key: "2",
                              type: "group",
                              label: "Outros",
                              children: usuarios
                                ?.filter((usr: any) =>
                                  usr.grupos.find(
                                    (g: any) => g.name !== "sponsor"
                                  )
                                )
                                ?.filter((usr: any) =>
                                  params.id ? usr.cliente_id === params.id : true
                                )
                                ?.map((usr: any) => {
                                  return {
                                    key: usr._id,
                                    label: usr.name,
                                    onClick: (v: any) => {
                                      setLoading(true);
                                      moduloTask
                                        .updateTaskAssignment(task._id, usr._id)
                                        .finally(() => setLoading(false));
                                    },
                                  };
                                }),
                            },
                          ],
                        }}
                        dropdownRender={(menu) => (
                          <div style={contentStyle}>
                            <Search
                              style={{
                                margin: "10px 18px",
                                width: "264px",
                              }}
                              placeholder="Buscar"
                              onSearch={handleSearch}
                              enterButton
                            />
                            <Divider style={{ margin: 0 }} />
                            {React.cloneElement(menu as React.ReactElement, {
                              style: menuStyle,
                            })}
                            <Divider style={{ margin: 0 }} />
                            <Space
                              style={{
                                padding: 8,
                                justifyContent: "flex-end",
                                display: "flex",
                              }}
                            >
                              <Button
                                type="primary"
                                icon={<UserAddOutlined />}
                                onClick={() => setShowModalNewUser(true)}
                              >
                                Novo usuário
                              </Button>
                            </Space>
                          </div>
                        )}
                      >
                        <div
                          className="microtask_user"
                          style={{ cursor: "pointer" }}
                        >
                          <Avatar
                            className="avatar-task"
                            src={`https://ui-avatars.com/api/?name=${task?.assignment_name?.replaceAll(
                              " ",
                              "+"
                            )}?background=ebebeb`}
                          />
                          <p>{task?.assignment_name || ""}</p>
                          <EditOutlined style={{ marginLeft: "0.5rem" }} />
                        </div>
                      </Dropdown>
                    </div>
                  </Tooltip>
                </div>
              </div>
            );
          })}

        {!moduloTask.selectedTask?.title?.includes("pauta") && (
          <>
            <p
              style={{
                marginTop: "1rem",
                marginBottom: "-2.5rem",
                fontWeight: "bold",
              }}
            >
              Comentários
            </p>
            {moduloTask.selectedTask && moduloTask.selectedTask._id && (
              <Comments task_id={moduloTask.selectedTask._id} />
            )}
          </>
        )}
      </Modal>
      <NewUser
        showModal={showModalNewUser}
        setShowModal={setShowModalNewUser}
      />
    </>
  );
};

export default Task;
